module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-hedo-bottom-01.2@2x.080b2766.jpg";